// src/pages/Archive/index.jsx
import React, { useState, useEffect } from 'react';
import { Layout, Typography, Spin, Alert, List } from 'antd';
import { Link } from 'react-router-dom';
import AppHeader from '../../components/header';
import AppFooter from '../../components/footer';
import { getArchivePosts } from '../../api/mockData'; // 修正导入名称
import { UserOutlined, CalendarOutlined, EyeOutlined } from '@ant-design/icons';
import './index.css';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const Archive = ({ loggedInUser, onLogout }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchArchivedPosts = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await getArchivePosts(); // 使用正确的函数名
        setPosts(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchArchivedPosts();
  }, []);

  // 按年份和月份分组文章
  const groupPostsByDate = (posts) => {
    const grouped = {};
    posts.forEach(post => {
      const date = new Date(post.date);
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // 月份从0开始，需要+1
      const key = `${year}-${month}`;
      
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(post);
    });
    
    // 按年月倒序排列
    return Object.keys(grouped)
      .sort((a, b) => b.localeCompare(a))
      .reduce((obj, key) => {
        obj[key] = grouped[key].sort((a, b) => new Date(b.date) - new Date(a.date));
        return obj;
      }, {});
  };

  const groupedPosts = groupPostsByDate(posts);

  return (
    <Layout className="blog-layout">
      <AppHeader onLogout={onLogout}/>
      
      <Content className="archive-content">
        <div className="archive-container">
          <Title level={1} className="archive-title">文章归档</Title>
          <Paragraph className="archive-subtitle">按时间顺序整理的所有文章</Paragraph>
          
          {loading ? (
            <div className="archive-loading">
              <Spin size="large" />
            </div>
          ) : error ? (
            <div className="archive-error">
              <Alert 
                message="加载失败" 
                description={error} 
                type="error" 
                showIcon 
              />
            </div>
          ) : Object.keys(groupedPosts).length === 0 ? (
            <div className="archive-error">
              <Alert 
                message="暂无文章" 
                description="还没有任何文章可以归档" 
                type="info" 
                showIcon 
              />
            </div>
          ) : (
            <div className="archive-list">
              {Object.entries(groupedPosts).map(([dateKey, posts]) => {
                const [year, month] = dateKey.split('-');
                const monthNames = [
                  '一月', '二月', '三月', '四月', '五月', '六月',
                  '七月', '八月', '九月', '十月', '十一月', '十二月'
                ];
                
                return (
                  <div key={dateKey} className="archive-section">
                    <Title level={3} className="archive-time">
                      {year}年 {monthNames[month - 1]}
                    </Title>
                    <List
                      itemLayout="vertical"
                      size="large"
                      dataSource={posts}
                      renderItem={post => (
                        <List.Item
                          key={post.id}
                          className="archive-item"
                          actions={[
                            <span key="author">
                              <UserOutlined /> {post.author}
                            </span>,
                            <span key="date">
                              <CalendarOutlined /> {new Date(post.date).toLocaleDateString('zh-CN')}
                            </span>,
                            <span key="views">
                              <EyeOutlined /> {post.views || 0} 次阅读
                            </span>
                          ]}
                        >
                          <List.Item.Meta
                            title={
                              <Link to={`/post/${post.id}`}>
                                {post.title}
                              </Link>
                            }
                            description={post.summary}
                          />
                        </List.Item>
                      )}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </Content>
      
      <AppFooter />
    </Layout>
  );
};

export default Archive;